import {useEffect} from 'react';

export function useWindowMutation(options: MutationObserverInit, handler: () => void) {
    useEffect(() => {
        if (typeof MutationObserver !== 'function') {
            return () => {};
        }

        const observer = new MutationObserver(handler);
        observer.observe(document, options);

        return () => {
            observer.disconnect();
        };
    }, [handler, options]);
}
